import { Icon } from '@/src/tools/icon';
import React from 'react';

import css from './css.module.less';

const WarningIcon = (props) => {
  return <Icon type='iconinfo1' className={css.errIconTitle} />;
};

export default WarningIcon;
